import { render } from "./TaxSwitcher.vue?vue&type=template&id=09a482a0"
import script from "./TaxSwitcher.vue?vue&type=script&lang=js"
export * from "./TaxSwitcher.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/resources/shop/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__